import { render } from "./SubiektDocumentDetails.vue?vue&type=template&id=b322ce70&scoped=true"
import script from "./SubiektDocumentDetails.vue?vue&type=script&lang=js"
export * from "./SubiektDocumentDetails.vue?vue&type=script&lang=js"

import "./SubiektDocumentDetails.vue?vue&type=style&index=0&id=b322ce70&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b322ce70"]])

export default __exports__